"use strict";
module.exports = {
    entityModel: 'orderFullfillmentCenter',
    events: {
        ORDER_FULLFILLMENT_CENTER_UPDATED: 'ORDER_FULLFILLMENT_CENTER_UPDATED',
        ORDER_FULLFILLMENT_CENTER_CREATED: 'ORDER_FULLFILLMENT_CENTER_CREATED',
        ORDER_FULLFILLMENT_CENTER_ACTIVATED: 'ORDER_FULLFILLMENT_CENTER_ACTIVATED',
        ORDER_FULLFILLMENT_CENTER_DEACTIVATED: 'ORDER_FULLFILLMENT_CENTER_DEACTIVATED',
    },
    actions: {
        get: 'v1.orderFullfillmentCenter.get',
        list: 'v1.orderFullfillmentCenter.list',
        activate: 'v1.orderFullfillmentCenter.activate',
        deactivate: 'v1.orderFullfillmentCenter.deactivate',
        writeOrderFullfillmentCenter: 'v1.orderFullfillmentCenter.writeOrderFullfillmentCenter',
        setDeliveryRules: 'v1.orderFullfillmentCenter.setDeliveryRules',
        setDeliveryRulesOverrides: 'v1.orderFullfillmentCenter.setDeliveryRulesOverrides',
        upsert: 'v1.orderFullfillmentCenter.upsert',
        upsertWhenEmpty: 'v1.orderFullfillmentCenter.upsertWhenEmpty',
        updateWhenEmpty: 'v1.orderFullfillmentCenter.updateWhenEmpty',
        update: 'v1.orderFullfillmentCenter.update',
    },
    orderFlowTypes: {
        standard: 'standard',
        email: 'email',
        freshx: 'freshx',
    },
    transportOptions: {},
};
